module.exports = "<p>delete works!</p>\r\n"